/** Collection API endpoints, merged into the platform API client. */
export const collectionApiEndpoints: Record<string, string> = {
  collectionSettings: "PATCH:/ext/collection/projects/:pk/settings/",
  projectCollection: "/projects/:pk/collection/",
  projectCollectionRecords: "/projects/:pk/collection/records/",
};
